export default __webpack_public_path__ + "static/media/leads.9e266422.svg";